import React from 'react';
import {
  NeutralTag as NeutralTagComponent,
  SecondaryTag as SecondaryTagComponent,
  SuccessTag as SuccessTagComponent,
  WarningTag as WarningTagComponent,
  DangerTag as DangerTagComponent,
} from '@grnhse/seedling/lib/birch/components/tags';
import styled from 'styled-components';

const TagWrapper = styled.div<{ bgColor?: string; fontColor?: string }>`
  div {
    ${(props) => props.bgColor && `background-color: ${props.bgColor};`}
    ${(props) =>
      props.fontColor &&
      `
      span[data-library="birch"] {
        color: ${props.fontColor};
      }
    `}
  }

  span {
    white-space: nowrap;
  }
`;

export const SecondaryTag = ({ text }: { text: string }) => {
  return (
    <TagWrapper>
      <SecondaryTagComponent text={text} />
    </TagWrapper>
  );
};

export const WarningTag = ({ text }: { text: string }) => {
  return (
    <TagWrapper>
      <WarningTagComponent text={text} />
    </TagWrapper>
  );
};

export const SuccessTag = ({ text }: { text: string }) => {
  return (
    <TagWrapper>
      <SuccessTagComponent text={text} />
    </TagWrapper>
  );
};

export const NeutralTag = ({ text }: { text: string }) => {
  return (
    <TagWrapper>
      <NeutralTagComponent text={text} />
    </TagWrapper>
  );
};

export const DangerTag = ({ text }: { text: string }) => {
  return (
    <TagWrapper>
      <DangerTagComponent text={text} />
    </TagWrapper>
  );
};

const StyledTag = ({
  text,
  bgColor,
  fontColor,
}: {
  text: string;
  bgColor?: string;
  fontColor?: string;
}) => {
  return (
    <TagWrapper bgColor={bgColor} fontColor={fontColor}>
      <SuccessTagComponent text={text} />
    </TagWrapper>
  );
};

export default StyledTag;
